var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "283641_sports_running_health_time_stopwatch_icon 1",
    clipPath: "url(#clip0_482_1119)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.888 18.1292C29.888 25.7868 23.68 31.9958 16.0213 31.9958C8.36266 31.9958 2.15466 25.7868 2.15466 18.1292C2.15466 10.8311 7.79626 4.86305 14.9547 4.31585V2.12918H13.888V-0.00415039H18.1547V2.12918H17.088V4.31585C20.2219 4.55585 23.0645 5.83372 25.2704 7.80705L26.688 6.38945L28.8213 8.52918L27.2832 10.0673C28.9141 12.3404 29.888 15.1159 29.888 18.1292ZM16.0213 6.39692C9.54133 6.39692 4.288 11.6502 4.288 18.1302C4.288 24.6102 9.54133 29.8625 16.0213 29.8625C22.5013 29.8625 27.7547 24.6102 27.7547 18.1302C27.7547 11.6492 22.5013 6.39692 16.0213 6.39692Z",
    fill: "#08A693"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5255 19.2967C16.6928 20.1294 15.3412 20.1294 14.5085 19.2967C13.6758 18.464 13.6758 17.1124 14.5085 16.2797C15.3412 15.447 16.6928 15.447 17.5255 16.2797L25.0679 16.2797L25.0679 17.7882L17.7638 19.0056C17.6906 19.1074 17.616 19.2062 17.5255 19.2967Z",
    fill: "#08A693"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_482_1119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallTime);
export default __webpack_public_path__ + "static/media/smallTime.50928908a91c208e1dbb99b15f490165.svg";
export { ForwardRef as ReactComponent };